import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import { addFileType } from '../../../actions/fileData';
import { Button, Form, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle, Table } from 'reactstrap';

class MetaValueToType extends Component {

    constructor(props,context) {
        super(props,context);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {postData: false, edit: false, 'fileType': false}

        this.checkValues = this.checkValues.bind(this);

    }

    componentWillMount()
    {

    }

    handleSubmit(e) {
        e.preventDefault();


        this.props.addFileType(
            this.props.clientPath.clientPath,
            this.state.postData,


        );
    }

    setInputState(e) {
      this.setState({
          postData: {...this.state.postData, [e.target.name]: e.target.value }

      });
    }

    setCheckedValue(e) {
        this.setState({
            postData: {...this.state.postData, [e.target.name]: e.target.checked ? 1 : 0 }
        })
    }

    checkValues(valueId) {
        let returnValue = {
            categoryChecked: false,
            mandatoryChecked: false
        };
        if(this.props.currentFile) {
            const currentFile = this.props.currentFile;

            if(currentFile.metacategories) {
                const metaCats = currentFile.metacategories;
                for(let i = 0; i <= metaCats.length; i++) {
                    if(metaCats[i]) {

                        if(metaCats[i]['id'] == valueId) {
                            returnValue.categoryChecked = true;

                            if(metaCats[i]['is_mandatory'] == '1') {
                                returnValue.mandatoryChecked = true;
                            }

                        }
                    }
                }
            }
        }

        return returnValue;
    }

    mapMetaValuesToCheckboxes(value, key) {


        let checkedValues = this.checkValues(value.id);


        return(
            <tr key={key}>
                <td>
                    <Label check for={"metacategory_"+value.id}>
                        <Input defaultChecked={checkedValues.categoryChecked} onChange={(e) => this.props.changeMetaCheckbox(e, value.id)} type="checkbox" id={"metacategory_"+value.id} name={"metacategory_"+value.id} />
                        &nbsp; {value.name}
                    </Label>
                </td>
                <td>
                    <Label check for={"metacategory_"+value.id}>
                        <span>{value.is_active === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
                    </Label>
                </td>
                <td>
                    <Label check for={"is_mandatory_"+value.id}>
                        <Input defaultChecked={checkedValues.mandatoryChecked} onChange={(e) => this.props.setMetaMandatory(e, value.id)} type="checkbox" id={"is_mandatory_"+value.id} name={"is_mandatory_"+value.id} />
                        &nbsp; Is verplicht
                    </Label>
                </td>
            </tr>
        )
    }
    render() {
        return (
            <div className="animated fadeIn">
                <br />
                <CardTitle><i className="fa fa-file"></i> Koppel metadatacategorie </CardTitle>
                <Table striped>
                    <thead>
                        <tr><th>Categorie</th><th>Is actief?</th><th>Is verplicht?</th></tr>
                    </thead>
                    <tbody>
                        {this.props.fileMetaDataCategories.data.map((value, key) => this.mapMetaValuesToCheckboxes(value, key))}
                    </tbody>
                </Table>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        fileTypeData: state.FileTypeDataReducer,
        clientPath: state.clientPathReducer,
        fileMetaDataCategories: state.FileMetaDataCategoryReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFileType: (url, postData) => dispatch(addFileType(url, postData))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MetaValueToType))



// WEBPACK FOOTER //
// ./src/views/Filetype/Metavalues/index.js